import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
export const entityTypeMasterService = createApi({
    reducerPath: 'entityTypeMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['Entity'],
    endpoints: (builder) => ({
        getAllEntityTypeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityTypeMasterController.getAllEntityTypeMaster}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getEntityTypeMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityTypeMasterController.getEntityTypeMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveEntityTypeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityTypeMasterController.saveEntityTypeMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateEntityTypeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityTypeMasterController.updateEntityTypeMaster}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteEntityTypeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityTypeMasterController.deleteEntityTypeMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAllEntityTypeMasterBySearch: builder.mutation({
            query(body) {
                console.log(body, "body");

                return {
                    url: `${userManagement.entityTypeMasterController.getAllEntityTypeMasterBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        findAllEntityTypeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityTypeMasterController.findAllEntityTypeMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkSaveEntityTypeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityTypeMasterController.bulkSaveEntityTypeMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});
export const {
    useGetAllEntityTypeMasterMutation,
    useGetEntityTypeMasterByIdMutation,
    useSaveEntityTypeMasterMutation,
    useUpdateEntityTypeMasterMutation,
    useDeleteEntityTypeMasterMutation,
    useGetAllEntityTypeMasterBySearchMutation,
    useFindAllEntityTypeMasterMutation,
    useBulkSaveEntityTypeMasterMutation,
} = entityTypeMasterService;